import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'

const OtherResources = () => (
  <Layout>
    <PageTitle name="External Resources" site="OIRA" />
    {/* <h2 id="from-our-office">From Our Office</h2>
    <ul>
      <li>
        <Link to="http://oira.ua.edu/factbook">Factbook</Link>
      </li>
      <li>
        <Link to="http://syllabi.ua.edu">Syllabus Archive (pre-Summer 2023)</Link>
      </li>
      <li>
        <Link to="http://oira.ua.edu/new/soi">
          Student Opinions of Instruction
        </Link>
      </li>
      <li>
        <Link to="https://oie.ua.edu">
          Office of Institutional Effectiveness
        </Link>
      </li>
    </ul> */}
    <h2 id="the-university-of-alabama-system">
      The University of Alabama System
    </h2>
    <ul>
      <li>
        <Link to="https://uasystem.edu/">
          The University of Alabama (UA) System
        </Link>

        <ul>
          {/* <li>
            <Link to="http://uasystem.ua.edu/ua-system-office/organizational-chart/">
              UA System Organizational Chart
            </Link>
          </li> */}
          <li>
            <Link to="https://uasystem.edu/board">
              The Board of Trustees
            </Link>
          </li>
          <li>
            <Link to="https://uasystem.edu/about">
              UA System Mission Statement
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="https://www.ua.edu/">The University of Alabama</Link>
      </li>
      <li>
        <Link to="https://www.uab.edu/">
          The University of Alabama at Birmingham
        </Link>
      </li>
      <li>
        <Link to="https://www.uah.edu/">
          The University of Alabama in Huntsville
        </Link>
      </li>
    </ul>
    <h2 id="institutional-research">Institutional Research</h2>
    <ul>
      {/* <li>
        <Link to="http://oira.ua.edu/chime-in/">
          Chime In
        </Link>
      </li> */}
      <li>
        <Link to="https://www.airweb.org/">
          Association for Institutional Research (AIR)
        </Link>

        <ul>
          <li>
            <Link to="https://www.airweb.org/resources/news/recentnews">
              IR Resources/News
            </Link>
          </li>
          <li>
            <Link to="https://www.airweb.org/resources/publications/eair-newsletter">
              E-Newsletter
            </Link>
          </li>
          <li>
            <Link to="https://www.airweb.org/?page=1156#professional">
              Professional Development
            </Link>
          </li>
          <li>
            <Link to="https://www.airweb.org/resources/publications/">Publications</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="https://www.sair.org/">
          Southern Association for Institutional Research (SAIR)
        </Link>
      </li>
      <li>
        <Link to="https://alair.org/">
          Alabama Association for Institutional Research (ALAIR)
        </Link>
      </li>
    </ul>
    <h2 id="periodicals">Periodicals</h2>
    <ul>
      <li>
        <Link to="https://www.chronicle.com/">Chronicle of Higher Education</Link>
      </li>
      <li>
        <Link to="https://www.edweek.org/">Education Week</Link>
      </li>
    </ul>
    <h2 id="state-of-alabama">State of Alabama</h2>
    <ul>
      <li>
        <Link to="https://www.ache.edu/">
          Alabama Commission for Higher Education (ACHE)
        </Link>
      </li>
      <li>
        <Link to="https://www.alabamacommunitiesofexcellence.org/resource/alabama-department-of-postsecondary-education-2/">
          Alabama Department of PostSecondary Education (DPE)
        </Link>
      </li>
      <li>
        <Link to="https://www.alabamaachieves.org/">
          Alabama State Department of Education (ALSDE)
        </Link>
      </li>
    </ul>
    <h2 id="federal-government">Federal Government</h2>
    <ul>
      <li>
        <Link to="https://nces.ed.gov/">
          National Center for Educational Statistics (NCES)
        </Link>
      </li>
      <li>
        <Link to="https://nces.ed.gov/ipeds/">
          Integrated Postsecondary Education Data System (IPEDS)
        </Link>

        <ul>
          <li>
            <Link to="https://nces.ed.gov/ipeds/use-the-data">IPEDS Data Center</Link>
          </li>
          <li>
            <Link to="https://nces.ed.gov/pubsearch/getpubcats.asp?sid=010">
              IPEDS Publications
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="https://www.ed.gov/">U.S. Department of Education</Link>
      </li>
      <li>
        <Link to="https://www.census.gov/">U.S. Census Bureau</Link>
      </li>
    </ul>
    <h2 id="higher-education">Higher Education</h2>
    <ul>
      <li>
        <Link to="https://agb.org/">
          Association of Governing Boards of Universities and Colleges (AGB)
        </Link>
      </li>
      <li>
        <Link to="https://www.chronicle.com/tag/data">
          The Chronicle of Higher Education: Data
        </Link>
      </li>
      <li>
        <Link to="https://www.ecs.org/">
          Education Commission of the States (ECS)
        </Link>
      </li>
      <li>
        <Link to="https://education.illinoisstate.edu/grapevine//">Grapevine</Link>
      </li>
      <li>
        <Link to="https://www.acenet.edu/">
          American Council on Education (ACE)
        </Link>
      </li>
      <li>
        <Link to="https://www.ihep.org/">
          The Institute for Higher Education Policy (IHEP)
        </Link>
      </li>
      <li>
        <Link to="https://nces.ed.gov/npec/">
          National Postsecondary Education Cooperative (NPEC)
        </Link>
      </li>
      <li>
        <Link to="https://www.sacscoc.org/">
        The Southern Association of Colleges and Schools Commission on Colleges (SACSCOC)
        </Link>
      </li>
      <li>
        <Link to="https://www.scup.org/">
          Society for College and University Planning (SCUP)
        </Link>
      </li>
      <li>
        <Link to="https://sheeo.org/">
          State Higher Education Executive Officers (SHEEO)
        </Link>
      </li>
      <li>
        <Link to="https://www.sreb.org/">
          Southern Regional Education Board (SREB)
        </Link>
      </li>
    </ul>
  </Layout>
)

export default OtherResources
